export default async ({ store }) => {
	if (!store.state.personalisation._uid) {
		await store.dispatch('loadPersonalisation');
	}
}